function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.43 1.136L1.135.43l13.435 13.435-.707.707L.43 1.136z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.136 14.571l-.707-.707L13.864.429l.707.707L1.136 14.571z",
  fill: "currentColor"
});

function SvgXinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgXinline;